import { render, staticRenderFns } from "./Material_master.vue?vue&type=template&id=0096eb81&"
import script from "./Material_master.vue?vue&type=script&lang=js&"
export * from "./Material_master.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports